import React from "react"
import moment from "moment"

export function formatWebinarSchedule(webinar) {
    if (!webinar) return ""
    const parts = []
    const day = webinar.selectDay || webinar.day || (webinar.webinarDate ? moment(webinar.webinarDate).format("dddd") : "")
    const formattedDate = webinar.webinarDate
        ? moment(webinar.webinarDate).format("DD MMMM YYYY")
        : (webinar.fromDate ? moment(webinar.fromDate, ["DD MMM YYYY", "YYYY-MM-DD", "DD/MM/YYYY"]).format("DD MMMM YYYY") : "")

    const dateStr = day && formattedDate ? `${day}, ${formattedDate}` : (formattedDate || day)

    if (dateStr) {
        parts.push(dateStr)
    }

    const startTime = webinar.startTime ? moment(webinar.startTime, ["HH:mm:ss", "HH:mm"]).format("hh:mm A") : ""
    const endTime = webinar.endTime ? moment(webinar.endTime, ["HH:mm:ss", "HH:mm"]).format("hh:mm A") : ""

    if (startTime && endTime) {
        parts.push(`${startTime}–${endTime} (India)`)
    } else if (startTime) {
        parts.push(`${startTime} (India)`)
    }

    return parts.join(" | ")
}

export const UpcomingWebinarSection = ({ webinar }) => {
    if (!webinar) return null
    const scheduleText = formatWebinarSchedule(webinar)
    const hasKeyTopics = Boolean(webinar.keyTopics && webinar.keyTopics.trim())

    return (
        <section
            aria-labelledby={`upcoming-webinar-${webinar.webinarID}`}
            className="row g-0 align-items-stretch overflow-hidden rounded shadow-sm mb-4 mb-lg-5"
            style={{ backgroundColor: "#f5f7f8" }}
        >
            <div className="col-lg-7 p-4 p-lg-5">
                <span
                    className="badge rounded-pill px-3 py-2 mb-3"
                    style={{ backgroundColor: "#cd9e53", color: "#16374e" }}
                >
                    Upcoming webinar
                </span>
                <h2
                    id={`upcoming-webinar-${webinar.webinarID}`}
                    className="fw-bold mb-3"
                    style={{ color: "#16374e" }}
                >
                    {webinar.title}
                </h2>
                <p className="fw-semibold mb-3" style={{ color: "#514d4d" }}>
                    {webinar.subTitle && <span className="d-block mb-1 text-uppercase">{webinar.subTitle}</span>}
                    {scheduleText && <span className="fw-bold text-dark">{scheduleText}</span>}
                </p>

                <div className="mb-3" style={{ color: "#333", textAlign: "justify" }}>
                    <p>{webinar?.description ? webinar?.description : '-'}</p>
                </div>

                <h3 className="h5 fw-bold mt-4 mb-3" style={{ color: "#16374e" }}>
                    Key topics
                </h3>
                {hasKeyTopics ? (
                    /<[a-z][\s\S]*>/i.test(webinar.keyTopics) ? (
                        <div className="mb-4" dangerouslySetInnerHTML={{ __html: webinar.keyTopics }} />
                    ) : (
                        <ul className="row row-cols-1 row-cols-md-2 g-2 ps-4 mb-4">
                            {webinar.keyTopics
                                .split(/[\r\n]+/)
                                .map((t) => t.trim())
                                .filter(Boolean)
                                .map((topic, index) => (
                                    <li key={index} className="pe-3">
                                        {topic}
                                    </li>
                                ))}
                        </ul>
                    )
                ) : (
                    <div className="text-muted mb-4">-</div>
                )}

                <div className="d-flex flex-wrap gap-2">
                    {webinar.registerLink && (
                        <a
                            className="btn fw-semibold px-4 py-2"
                            href={webinar.registerLink}
                            target="_blank"
                            rel="noreferrer"
                            style={{ backgroundColor: "#16374e", color: "#fff" }}
                        >
                            Register for the webinar
                        </a>
                    )}
                    {/* {webinar.meetingLink && (
                        <a
                            className="btn fw-semibold px-4 py-2"
                            href={webinar.meetingLink}
                            target="_blank"
                            rel="noreferrer"
                            style={{ backgroundColor: "#cd9e53", color: "#16374e", fontWeight: "bold" }}
                        >
                            Join Meeting
                        </a>
                    )} */}
                </div>
            </div>

            <div
                className="col-lg-5 d-flex align-items-center justify-content-center p-3 p-lg-4"
                style={{ backgroundColor: "#16374e" }}
            >
                <img
                    src={webinar.sidePhotoPath}
                    alt={webinar.title || "MILSO Academy upcoming webinar announcement"}
                    onError={(e) => {
                        e.currentTarget.onerror = null
                        e.currentTarget.src = "/Static/Assets/Img/Webinars/UpWeb.png"
                    }}
                    className="img-fluid rounded"
                    style={{
                        width: "100%",
                        maxHeight: "620px",
                        objectFit: "contain",
                        boxShadow: "8px 8px #cd9e53",
                    }}
                />
            </div>
        </section>
    )
}
